import { LicenseWebPageInvoiceSubmittalItem } from 'commons/types/DTO/bank/license'
import { formatCurrencyCent } from 'commons/utils'
import { DateTime } from 'ui/components/DateTime'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'

export const useColumns = (
  deleteInvoice: ({ id }: { id: number }) => void
): TableColumn<LicenseWebPageInvoiceSubmittalItem>[] => [
  {
    title: 'Invoice Submittal Number',
    render: ({ id }) => (
      <Link to="/invoices/$id" params={{ id: id.toString() }}>
        IS-{id}
      </Link>
    )
  },
  {
    title: 'Amount',
    render: ({ amount }) => formatCurrencyCent(amount)
  },
  {
    key: 'notes',
    title: 'Notes'
  },
  {
    title: 'Last Modified Date',
    render: ({ updatedAt }) => <DateTime date={updatedAt} />
  },
  {
    title: 'Actions',
    align: 'center',
    width: '50px',
    render: (item) => (
      <TableActions
        items={[
          {
            type: 'edit',
            url: `/invoices/${item.id}/edit`
          },
          {
            type: 'delete',
            onClick: () => deleteInvoice({ id: item.id })
          }
        ]}
      />
    )
  }
]
